import { useQuery } from "react-query";

import { AxiosError } from "@bps/http-client";
import { useGateways } from "@libs/api/gateways-context";
import { Permissions } from "@libs/permissions/permissions.enum";

import { usePermissionsCheckQuery } from "../env/env-gateway.hooks";
import {
  OpsReportDefinition,
  OpsReportDefinitionGetOptions,
  OpsReportInstance,
  ReportDefinitionArgs
} from "./plt-reports-ops-gateway.dtos";

export enum PltReportsOpsCacheKeys {
  Definitions = "plt-reports-ops-definitions",
  Instance = "plt-reports-ops-instance"
}

export const useOpsReportsDefinitions = (filterArgs?: ReportDefinitionArgs) => {
  const { pltReportsOpsGateway } = useGateways();
  return useQuery<OpsReportDefinition[], AxiosError>(
    [PltReportsOpsCacheKeys.Definitions, filterArgs],
    async () => {
      return await pltReportsOpsGateway.getOpsReportDefinitions(filterArgs);
    }
  );
};

export const useOpsReportInstance = (
  name?: string,
  getOptions?: OpsReportDefinitionGetOptions
) => {
  const { pltReportsOpsGateway } = useGateways();

  return useQuery<OpsReportInstance, AxiosError>(
    [PltReportsOpsCacheKeys.Instance, name, getOptions],
    async () => {
      return await pltReportsOpsGateway.getOpsReportInstanceByName(
        name!,
        getOptions!
      );
    }
  );
};

export const useOpsReportsPermissionsQuery = () => {
  const permissionsQuery = usePermissionsCheckQuery(
    [Permissions.OpsReportRead],
    "and"
  );
  return permissionsQuery;
};
